import React from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { 
  Phone, 
  MapPin, 
  Globe,
  ArrowRight
} from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
            {/* Company Info */}
            <div className="lg:col-span-2">
              <div className="mb-6">
                <h3 className="text-2xl font-bold text-white mb-2">
                  SHADOWTACT
                  <span className="text-emerald-400 ml-1">SARL</span>
                </h3>
                <p className="text-slate-300 leading-relaxed">
                  Votre partenaire de confiance pour l'import-export et la vente 
                  en ligne de produits électroniques, ménagers, vêtements et 
                  articles de première nécessité.
                </p>
              </div>
              
              <div className="mb-6">
                <Button className="bg-emerald-600 hover:bg-emerald-700 text-white mb-4">
                  <Phone className="w-4 h-4 mr-2" />
                  01 85 09 91 73
                </Button>
                <p className="text-sm text-slate-400">
                  N'hésitez pas à nous appeler pour toute question
                </p>
              </div>
            </div>

            {/* Navigation */}
            <div>
              <h4 className="text-lg font-semibold text-white mb-4">Navigation</h4>
              <ul className="space-y-2">
                <li>
                  <Link 
                    to="/" 
                    className="text-slate-300 hover:text-emerald-400 transition-colors flex items-center group"
                  >
                    Accueil
                    <ArrowRight className="w-4 h-4 ml-1 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/contact" 
                    className="text-slate-300 hover:text-emerald-400 transition-colors flex items-center group"
                  >
                    Contact
                    <ArrowRight className="w-4 h-4 ml-1 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </Link>
                </li>
              </ul>
            </div>

            {/* Legal */}
            <div>
              <h4 className="text-lg font-semibold text-white mb-4">Informations légales</h4>
              <ul className="space-y-2">
                <li>
                  <Link 
                    to="/cgu" 
                    className="text-slate-300 hover:text-emerald-400 transition-colors flex items-center group"
                  >
                    CGU
                    <ArrowRight className="w-4 h-4 ml-1 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/mentions-legales" 
                    className="text-slate-300 hover:text-emerald-400 transition-colors flex items-center group"
                  >
                    Mentions légales
                    <ArrowRight className="w-4 h-4 ml-1 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-lg font-semibold text-white mb-4">Contact</h4>
              <div className="space-y-3">
                <div className="flex items-start">
                  <MapPin className="w-5 h-5 text-emerald-400 mr-3 mt-0.5 flex-shrink-0" />
                  <div className="text-slate-300 text-sm">
                    5, Allée de la Grande Treille<br />
                    35200 Rennes
                  </div>
                </div>
                <div className="flex items-center">
                  <Phone className="w-5 h-5 text-emerald-400 mr-3 flex-shrink-0" />
                  <span className="text-slate-300 text-sm">01 85 09 91 73</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="max-w-6xl mx-auto">
            <div className="flex flex-col sm:flex-row items-center justify-center">
              <p className="text-slate-400 text-sm text-center">
                © 2025 SHADOWTACT SARL. Tous droits réservés.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;